import axios from "axios";

export function getXtgxs() {
  return axios({
    url: "/api/xtglXtgx/getxtgxs",
    method: "get",
  });
}

export function addXtgx2(param) {
  return axios({
    url: "/api/xtglXtgx/addxtgx2",
    method: "post",
    data: param,
  });
}

export function updateXtgx(param) {
  return axios({
    url: "/api/xtglXtgx/updatextgx",
    method: "post",
    data: param,
  });
}

export function delXtgx(param) {
  return axios({
    url: "/api/xtglXtgx/delxtgx",
    method: "post",
    data: param,
  });
}

export function updateXt() {
  return axios({
    url: "/api/xtglXtgx/updatext",
    method: "get",
  });
}